<script setup>
const { data } = defineProps(['data'])
const ICON_HEIGHT = 20

const icons = data?.map(({ id, fields: { icon: rawIcon, altText } }) => {
  const icon = { id, altText }
  if (rawIcon?.fields) {
    const { file } = rawIcon.fields
    icon.url = file?.url
    icon.width = file?.details?.image?.width
    icon.height = file?.details?.image?.height
    icon.aspectRatio = icon.width && icon.height ? icon.width / icon.height : 1
  }
  return { icon }
})
</script>

<template>
  <div class="footer__payment-icons">
    <img
      v-for="{ icon } of icons"
      :key="icon.id"
      :src="icon.url"
      :alt="icon.altText"
      :width="Math.floor(ICON_HEIGHT * icon.aspectRatio)"
      :height="ICON_HEIGHT"
      class="footer__payment-icons-img"
      loading="lazy"
    />
  </div>
</template>

<style scoped lang="postcss">
.footer__payment-icons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-50);

  .footer__payment-icons-img {
    width: 2.5rem;
    height: auto;
  }
}
</style>
